import { SalePhase } from './misc'

type MerkleProofTable = {
  [walletAddress in string]: string[]
}

const fetchWhitelistJson = async (path: string) => {
  return fetch(path)
    .then((res) => res.json() as Promise<MerkleProofTable>)
    .catch((err) => {
      console.error(err)
      return {} as MerkleProofTable
    })
}

/* eslint-disable no-case-declarations */

export const getGeneratedMerkleProof = async (walletAddress: string, phase: SalePhase) => {
  const isProd = process.env.REACT_APP_RELEASE_STAGE === 'production'
  let proof = {}
  switch (phase) {
    case SalePhase.WHITELIST:
      proof = await fetchWhitelistJson(
        isProd
          ? '/constants/vvsMinerMole/whitelistProd/round1.json'
          : '/constants/vvsMinerMole/whitelistDev/round1.json',
      )
      return proof[walletAddress.toLowerCase()] || []

    case SalePhase.PRESALE:
      proof = await fetchWhitelistJson(
        isProd
          ? '/constants/vvsMinerMole/whitelistProd/round2.json'
          : '/constants/vvsMinerMole/whitelistDev/round2.json',
      )
      return proof[walletAddress.toLowerCase()] || []

    case SalePhase.PUBLIC:
    default:
      return []
  }
}
